import { ChangeDetectionStrategy, Component, inject, OnInit, signal, type WritableSignal } from "@angular/core";
import {
  Router,
  RouteConfigLoadStart,
  RouteConfigLoadEnd,
  ChildrenOutletContexts,
  NavigationError,
} from "@angular/router";
import { filter } from "rxjs/operators";
import { RouterOutlet } from "@angular/router";
import { slideInAnimation } from "@shared/animations/my-route-animation";
import { PushNotificationService } from "@shared/services/push-notification/push-notification.service";
import { DomainService } from "@shared/services/domain/domain.service";
import { SessionUserDataService } from "@shared/services/user-data/session-user-data.service";
import { GlobalChangesService } from "@shared/services/global-changes/global-changes.service";
import { QueryErrorAlertComponent } from "@shared/components/utility/query-error-alert/query-error-alert.component";
import { CustomToastComponent } from "@core/components/custom-toast/custom-toast.component";
import { ConnectivityService } from "@shared/services/connectivity/connectivity.service";
import { ConnectivityStatusEnum } from "@core/enums/connectivity-status.enum";
import { TranslateModule } from "@ngx-translate/core";
@Component({
  selector: "app-root",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [slideInAnimation],
  imports: [RouterOutlet, QueryErrorAlertComponent, CustomToastComponent, TranslateModule],
})
export class AppComponent implements OnInit {
  /** Lo escribe la suscripcion a los eventos del router, no un evento de plantilla. */
  readonly loadingRouteConfig: WritableSignal<boolean> = signal<boolean>(false);

  public avatar!: string;
  public userName!: string;

  private readonly router: Router = inject(Router);
  private readonly contexts: ChildrenOutletContexts = inject(ChildrenOutletContexts);
  private readonly pushNotification: PushNotificationService = inject(PushNotificationService);
  readonly domainService: DomainService = inject(DomainService);
  readonly userDataService: SessionUserDataService = inject(SessionUserDataService);
  readonly globalChangesService: GlobalChangesService = inject(GlobalChangesService);
  readonly connectivityService: ConnectivityService = inject(ConnectivityService);
  readonly ConnectivityStatusEnum: typeof ConnectivityStatusEnum = ConnectivityStatusEnum;

  loadingRoute(): void {
    this.router.events
      .pipe(
        filter(
          (event): event is RouteConfigLoadStart | RouteConfigLoadEnd | NavigationError =>
            event instanceof RouteConfigLoadStart ||
            event instanceof RouteConfigLoadEnd ||
            event instanceof NavigationError
        )
      )
      .subscribe((event) => {
        this.loadingRouteConfig.set(event instanceof RouteConfigLoadStart);
      });
  }

  getAnimationData() {
    return this.contexts.getContext("primary")?.route?.snapshot?.data?.[
      "animation"
    ];
  }

  cloudMessaging(): void {
    this.pushNotification.cloudMessaging();
  }


  ngOnInit(): void {
    this.loadingRoute();
    this.cloudMessaging();
    this.globalChangesService.listenToGlobalChanges();
  }
}
